import api, { ApiResponse } from "../api";
import { apiQueryAdapter } from "../apiQueryAdapter";
import { TerminalRequestModel, UpdateAddress, UpdateContact, UpdateRegion, UpdateBasicInfo, AdditionalSettings, UpdateStatus } from "./models";

class TerminalService {
  private static instance: TerminalService;
  private constructor() { }

  static getInstance(): TerminalService {
    if (!TerminalService.instance) {
      TerminalService.instance = new TerminalService();
    }
    return TerminalService.instance;
  }

  public getTerminalSummaryByTerminalNumber = async (
    terminalNumber: string
  ): Promise<ApiResponse<any>> => {
    return await api.get(`/terminals/${terminalNumber}`);
  };

  public addNewTerminal = async (
    data: TerminalRequestModel
  ): Promise<ApiResponse<any>> => {
    return await api.post(`/terminals`, data);
  };

  public updateTerminalSummaryByTerminalNumber = async (
    terminalNumber: string,
    data: TerminalRequestModel
  ): Promise<ApiResponse<any>> => {
    return await api.put(`/terminals/${terminalNumber}`, data);
  };

  public updateTerminalSummaryByBasicInfo = async (
    terminalNumber: string,
    data: UpdateBasicInfo
  ): Promise<ApiResponse<any>> => {
    return await api.put(`/terminals/${terminalNumber}/basic-info`, data);
  };

  public updateTerminalStatus = async (
    terminalNumber: string,
    data: UpdateStatus
  ): Promise<ApiResponse<any>> => {
    return await api.put(`/terminals/${terminalNumber}/status`,null, {
      params: {
        status: data.status
      }
    });
  };

  public updateTerminalAddressById = async (
    terminalNumber: string,
    addressId: string,
    data: UpdateAddress
  ): Promise<ApiResponse<any>> => {
    return await api.put(`/terminals/addresses/${terminalNumber}/address/${addressId}`, data);
  };

  public updateTerminalContactById = async (
    terminalNumber: string,
    contactId: string,
    data: UpdateContact
  ): Promise<ApiResponse<any>> => {
    return await api.put(`/terminals/contacts/${terminalNumber}/contact/${contactId}`, data);
  };

  public updateTerminalRegionById = async (
    terminalNumber: string,
    regionId: string,
    data: UpdateRegion
  ): Promise<ApiResponse<any>> => {
    return await api.put(`/terminals/regions/${terminalNumber}/region/${regionId}`, data);
  };

  public getAdditionalSettings = async (
    terminalNumber: string,
  ): Promise<ApiResponse<any>> => {
    return await api.get(`/terminals/${terminalNumber}/terminalSettings`);
  };

  public updateAdditionalSettings = async (
    terminalNumber: string,
    data: AdditionalSettings
  ): Promise<ApiResponse<any>> => {
    return await api.put(`/terminals/${terminalNumber}/terminalSettings`, data);
  };

  public deleteTerminalByTerminalNumber = async (
    terminalNumber: string,
  ): Promise<ApiResponse<any>> => {
    return await api.delete(`/terminals/${terminalNumber}`);
  };

  public deleteTerminalRequest = async (
    terminalNumber: string,
    terminalName: string,
    reason: string,
    comment: string | null
  ): Promise<any> => {
    const response = await apiQueryAdapter.query(
      `/terminal-deletion-requests`,
      "POST",
      {
        body: {
          terminalNumber,
          terminalName,
          reason,
          comment
        }
      }
    );
    return response.data;
  };

  public getTerminalDeletionRequest = async (
    terminalNumber: string,
  ): Promise<any> => {
    const response = await apiQueryAdapter.query(
      `/terminal-deletion-requests/${terminalNumber}`,
      "GET",
    );
    return response.data;
  };

  public updateTerminalName = async (
    terminalNumber: number,
    name: string
  ): Promise<any> => {
    const response = await apiQueryAdapter.query(
      `/terminals/${terminalNumber}/name?name=${name}`,
      "PUT",
    );
    return response.data;
  };
}

export default TerminalService;